<div class="loader-overlay" *ngIf="loading$ | async">
    <div class="loader-content">
        <div class="spinner-border text-primary" role="status">
        </div>
        <div class="loading-text">
            Cargando Informacion...
        </div>
    </div>
</div>